import { apiFetch } from "./api";

export type RetirementKind = "context" | "session";
export interface RetirementRecord {
  kind: RetirementKind;
  id: string;
  name: string;
  context_id: string | null;
  retired_at: string | null;
  registered_sessions: number;
  retained_snapshot_bytes: number;
  physical_resources_released: false;
}

function isRecord(value: unknown): value is RetirementRecord {
  if (!value || typeof value !== "object") return false;
  const record = value as Record<string, unknown>;
  return (record.kind === "context" || record.kind === "session") &&
    typeof record.id === "string" && typeof record.name === "string" &&
    (record.context_id === null || typeof record.context_id === "string") &&
    (record.retired_at === null || (typeof record.retired_at === "string" && !Number.isNaN(Date.parse(record.retired_at)))) &&
    typeof record.registered_sessions === "number" && Number.isSafeInteger(record.registered_sessions) && record.registered_sessions >= 0 &&
    typeof record.retained_snapshot_bytes === "number" && Number.isSafeInteger(record.retained_snapshot_bytes) && record.retained_snapshot_bytes >= 0 &&
    record.physical_resources_released === false;
}

export async function listRetirements(): Promise<RetirementRecord[]> {
  const response = await apiFetch("/retirements");
  if (!response.ok) throw new Error("Archives momentanément indisponibles.");
  const value: unknown = await response.json();
  if (!Array.isArray(value) || !value.every(isRecord)) throw new Error("Réponse d’archives invalide.");
  return value;
}

export async function setRetirement(kind: RetirementKind, id: string, retired: boolean): Promise<RetirementRecord> {
  const response = await apiFetch(`/retirements/${kind}/${encodeURIComponent(id)}`, {
    method: "POST", body: JSON.stringify({ retired }),
  });
  if (!response.ok) {
    if (response.status === 409) throw new Error("Archive non confirmée : arrêtez et laissez terminer les opérations. Pour restaurer une session, restaurez d’abord son contexte. Aucune donnée n’a été supprimée.");
    throw new Error(`Opération d’archive non confirmée (HTTP ${response.status}). Actualisez les listes avant de réessayer.`);
  }
  const value: unknown = await response.json();
  if (!isRecord(value) || value.id !== id || value.kind !== kind || (value.retired_at !== null) !== retired) {
    throw new Error("État d’archive non confirmé. Actualisez les listes ; aucun essai automatique.");
  }
  return value;
}
